module.exports = __webpack_public_path__ + "static/media/venue.31fa6904.svg";